module.exports = __webpack_public_path__ + "img/s4-title.70b53c6b.png";